import styled from 'styled-components';
import { Col, Radio } from 'antd';

import { Title } from '@/components/Typography';

interface ContainerStepProps {
	$isSmallScreen?: string;
}

export const PreviousCol = styled(Col)`
	padding: 0;
	margin-right: 1rem;

	@media (min-width: 576px) {
		margin-right: 4rem;
	}
	#work_schedule_hours_help {
		position: absolute;
	}
`;

export const ContainerStep = styled(Col)<ContainerStepProps>`
	padding: 2rem 1rem;
	border-radius: 1rem;
	background-color: #f8f8f8;
	margin-left: ${({ $isSmallScreen }) => ($isSmallScreen ? '0' : '2rem')};
`;

export const CustomRadioGroup = styled(Radio.Group)`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const RadioButtonTitle = styled(Col)`
	padding-right: 2rem;
`;

export const ResultTitle = styled(Title)`
	margin-bottom: 2.5rem;
`;
